import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { Table, TableCombination } from "~/providers/table-provider";

interface TableStoreState {
  currentTable?: Table;
  currentTableCombination?: TableCombination;
  setCurrentTable: (table?: Table) => void;
  tableDialogOpen: boolean;
  setTableDialogOpen: (table: boolean) => void;
  tableContextOpen?: Table;
  tableCombinationDialogOpen: boolean;
  setTableContextOpen: (table?: Table) => void;
  setTableCombinationDialogOpen: (open: boolean) => void;
  setCurrentTableCombination: (tableCombination?: TableCombination) => void;
}

export const useTableStore = create<TableStoreState>()(
  devtools((set) => ({
    tableDialogOpen: false,
    tableCombinationDialogOpen: false,
    setTableDialogOpen(open) {
      set(() => ({ tableDialogOpen: open }));
    },
    setTableContextOpen: (table) => {
      set(() => ({ tableContextOpen: table }));
    },
    setCurrentTable: (table) => {
      set(() => ({ currentTable: table }));
    },
    setTableCombinationDialogOpen: (tableCombination) => {
      set(() => ({ tableCombinationDialogOpen: tableCombination }));
    },
    setCurrentTableCombination: (tableCombination) => {
      set(() => ({ currentTableCombination: tableCombination }));
    },
  })),
);
